export default "__VITE_ASSET__CNUNVsG8__"